<template>
  <div class="app-wrapper">
    <h1>v1 Copyright Policy</h1>
    <p><strong>Last Updated 12th December 2024</strong></p>
    <p>
      Mappr is committed to respecting the intellectual property rights of
      others. In accordance with Spain’s Intellectual Property Law (Ley de
      Propiedad Intelectual), we will address claims of copyright infringement
      promptly and effectively. This policy outlines the steps to notify Mappr
      of alleged infringements and the procedure for responding to such
      notifications.
    </p>
    <h3>1. Notification of Alleged Copyright Infringement</h3>
    <p>
      If you believe that content hosted on Mappr infringes your intellectual
      property rights, please provide a written notice containing the following
      information:
    </p>
    <ul>
      <li>Your full name, address, telephone number, and email address.</li>
      <li>
        A description of the copyrighted work that you claim has been infringed.
      </li>
      <li>
        The URL or other specific location on Mappr where the allegedly
        infringing material is located.
      </li>
      <li>
        A statement that you have a good faith belief that the use of the
        material is not authorized by the copyright owner, their agent, or
        applicable law.
      </li>
      <li>
        A declaration under penalty of perjury that the information in your
        notice is accurate and that you are the copyright owner or authorized to
        act on behalf of the copyright owner.
      </li>
      <li>Your physical or electronic signature.</li>
    </ul>
    <p>
      Send your notice to the following contact:<br />
      <b>Email</b>: <a href="mailto:info@mappr.com">info@mappr.com</a><br />
      <b>Postal Address</b>: <br />
      Mapprexplore SL<br />
      Plaça Vicens Martorell 2, PB L 2<br />
      08001
      <br />Barcelona, España.
    </p>
    <h3>2. Take-Down Procedure</h3>
    <p>
      Upon receipt of a valid copyright infringement notice, Mappr will: 1
      Remove or disable access to the allegedly infringing content. 2 Notify the
      creator or user responsible for the content of the claim.3.
      Counter-Notification If you believe your content was removed in error, you
      may submit a counter-notification with the following details:
    </p>
    <ul>
      <li>Your full name, address, telephone number, and email address.</li>
      <li>
        Identification of the content that was removed and its original
        location.
      </li>
      <li>
        A statement under penalty of perjury that you have a good faith belief
        the content was removed due to mistake or misidentification.
      </li>
      <li>
        A declaration that you consent to the jurisdiction of Spanish courts.
      </li>
      <li>
        Your physical or electronic signature. Send your counter-notice to the
        contact provided above. Upon receipt, Mappr may reinstate the content if
        no legal action is initiated by the copyright owner within 14 days.
      </li>
    </ul>
  </div>
</template>
